/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FeeScheduleEntryViewModel } from './feeScheduleEntryViewModel';

export interface FeeScheduleViewModel {
  id?: string;
  datasetId?: string;
  name?: string | null;
  inactive?: boolean;
  readonly active?: boolean;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  isDeleted?: boolean;
  feeScheduleEntries?: Array<FeeScheduleEntryViewModel> | null;
  deletedBy?: string | null;
  deletedDate?: string | null;
}
